import dayjs from 'dayjs'

const sendViewBranchTrackingCode = (app, branch, platform) => {
  app.$gtm.push({ ecommerce: null })
  app.$gtm.push({
    event: 'view_branch',
    ecommerce: {
      detail: {
        products: [
          {
            name: branch.name,
            id: branch.bid,
            industry_type: branch.industry_name,
            industry_id: branch.industry_id,
            platform,
          },
        ],
      },
    },
  })
}

const getPurchaseEventData = (order, productInfo, user) => {
  const bookingTotalAmount = order.total_amount
  const promo = order.promo
  const productQuantity =
    order.upgrades.reduce((accumulator, upgrade) => {
      return upgrade.qty + accumulator
    }, 0) ||
    order.product.qty ||
    1
  const bookingPrice = parseFloat((bookingTotalAmount / productQuantity).toFixed(2))

  const purchaseData = {
    currencyCode: order.txn_info.symbol_code,
    orderID: order.id,
    bookingTotalAmount,
    promoDiscount: promo.discount,
    usedFunCoin: order.bonus_discount,
    promoTitle: promo.name || '',
    product: {
      productName: productInfo.product_name,
      pid: productInfo.pid,
      branchName: order.branch_name,
      categoryID: productInfo.category_id,
      tags: productInfo.tags,
      categoryName: productInfo.category_name,
      regionID: productInfo.region_id,
      rrp: productInfo.rrp,
    },
    bookingPrice,
    productQuantity,
    bookingStartDate: dayjs(order.booking_time).format('YYYY-MM-DD'),
    bookingEndDate: dayjs(order.end_time_text).format('YYYY-MM-DD'),
    user: {
      email: user?.email || '',
      phone: user?.phone || '',
    },
  }

  return purchaseData
}

export { getPurchaseEventData, sendViewBranchTrackingCode }
